const INITIAL_STATE = {
  data: {}, 
  tickets: {},
  report:{}, 
  errors: {}
}
                  
const cancellationSummaryReport = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_CANCELLATION_SUMMARY_REPORT_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, report: action.data }
  case 'GET_CANCELLATION_SUMMARY_REPORT_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
            
export default cancellationSummaryReport;